import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hr-settings-shell',
  templateUrl: './settings-shell.component.html',
  styleUrls: ['./settings-shell.component.less'],
  standalone: false,
})
export class SettingsShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
